import { observer } from 'mobx-react';
import Panel from 'app/components/Panel';
import { useStore } from 'app/context';
import { useEffect, useState } from 'react';
import { DatenStandModel } from 'app/stores/datenstand.store';

interface AnalyticsStoreDetailProps {
    dataType: string;
    onClose: () => void;
}

export const AnalyticsStoreDetail = observer(({ dataType, onClose }: AnalyticsStoreDetailProps) => {
    const { adminDatenStandStore: datenStandStore } = useStore();
    const [item, setItem] = useState<DatenStandModel | null>(null);

    useEffect(() => {
        datenStandStore.findAll().then(res => {
            const found = res.find(r => r.dataType === dataType && !!r.analyticsStore);
            setItem(found || null);
        });
    }, [datenStandStore, dataType]);

    if (!item) {
        return null;
    }

    const sections = [
        { label: 'DB Table', value: item.dbTable || '—' },
        { label: 'Supports Time Range', value: item.supportsTimeRange ? 'Yes' : 'No' },
        { label: 'Aggregation Strategy', value: item.aggStrategy || '—' },
    ];

    const listSections = [
        { label: 'Dimensions', items: item.dimensions },
        { label: 'Aggregate Methods', items: item.aggregateMethods },
        { label: 'Non-Aggregate Methods', items: item.nonAggregateMethods },
        { label: 'Aggregatable Fields', items: item.aggregatableFields },
        { label: 'Non-Aggregatable Fields', items: item.nonAggregatableFields },
    ];

    return (
        <Panel title={item.analyticsStore || dataType} subtitle={dataType} onClose={onClose} header={<></>}>
            <div className="pad-1rem">
                <table className="table" style={{ width: '100%' }}>
                    <tbody>
                        {sections.map((s, i) => (
                            <tr key={i}>
                                <td style={{ fontWeight: 'bold', width: '200px' }}>{s.label}</td>
                                <td>{s.value}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {listSections.map((section, i) => (
                    <div key={i} style={{ marginTop: '16px' }}>
                        <strong>{section.label}</strong>
                        {section.items && section.items.length > 0 ? (
                            <ul style={{ margin: '4px 0', paddingLeft: '20px', fontSize: '12px', fontFamily: 'monospace' }}>
                                {section.items.map((m, j) => <li key={j}>{m}</li>)}
                            </ul>
                        ) : (
                            <div style={{ color: '#999', fontSize: '12px', marginTop: '4px' }}>none</div>
                        )}
                    </div>
                ))}
            </div>
        </Panel>
    );
});
